import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginModule } from './login/login.module';
import { ActionPlanModule } from './action-plans/action-plans.module';
import { EnterpriseModule } from './enterprise/enterprise.module';
import { ForgotPasswordModule } from './forgot-password/forgot-password.module';
import { ForgotPasswordTokenModule } from './forgot-password-token/forgot-password-token.module';
import { NewPasswordTokenModule } from './new-password-token/new-password-token.module';

@NgModule({
  imports: [
    CommonModule,
    LoginModule,
    ActionPlanModule,
    EnterpriseModule,
    ForgotPasswordModule,
    ForgotPasswordTokenModule,
    NewPasswordTokenModule
  ],
  declarations: []
})
export class AuthModule { }



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/pages/auth/auth.module.ts